import { render, staticRenderFns } from "./SectionShortText.vue?vue&type=template&id=53f32775&scoped=true&"
import script from "./SectionShortText.vue?vue&type=script&lang=js&"
export * from "./SectionShortText.vue?vue&type=script&lang=js&"
import style0 from "./SectionShortText.vue?vue&type=style&index=0&id=53f32775&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f32775",
  null
  
)

export default component.exports